import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faSignInAlt} from '@fortawesome/pro-solid-svg-icons';
import {canCheckIn} from '../enablers';
import {AssetActionLabel} from '../locales';
import {type IAsset} from '../schema';
import {ASSET_EVENT} from './constants';

export const assetActionCheckinIcon = faSignInAlt;

/**
 * Checkin asset
 * @param params
 * @returns Action
 */
export const assetActionCheckin = (
	asset?: IAsset,
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'asset-checkin',
	cb: () => dispatcher.trigger(ASSET_EVENT.CHECKIN, asset),
	enableTest: () => canCheckIn(asset),
	get label() {
		return AssetActionLabel.CHECKIN;
	},
	icon: assetActionCheckinIcon,
	...params,
});

export default assetActionCheckin;
